import { ReactNode } from 'react';
import { css } from '@emotion/css';

const containerClassName = css({
  width: '95%',
  maxWidth: '500px',
  paddingTop: '16px',
});

const Module: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className={containerClassName}>{children}</div>
);

export default Module;
